import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin, Mail, Twitter } from "lucide-react";
export default function CollegamentiSocial() {
  const socialLinks = [{
    icon: Linkedin,
    label: "LinkedIn",
    href: "#"
  }];
  return <section id="collegamenti-social" className="w-full bg-background py-16">
      <div className="container mx-auto flex flex-col items-center justify-center gap-8 px-4">
        <span className="font-mono text-xs tracking-widest text-foreground uppercase opacity-80">
          Connettiti con lo Studio
        </span>

        <div className="flex items-center gap-8">
  {socialLinks.map((item, i) => <a key={i} href="https://www.linkedin.com/company/dclegal-studio-legale/" target="_blank" rel="noopener noreferrer" className="group relative flex items-center justify-center p-2 transition-transform duration-500 ease-out hover:scale-[1.02]" data-index={i} onClick={e => e.stopPropagation()}>
    <item.icon strokeWidth={1.5} className="h-8 w-8 text-foreground transition-all duration-300 group-hover:text-ring group-hover:drop-shadow-[0_0_8px_var(--color-ring)]" />
    <span className="sr-only">{item.label}</span>
  </a>)}

        </div>
      </div>
    </section>;
}